/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTROL : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme =>({
    control: {
        height: pxToEm(46),
        minWidth: pxToEm(140), // 165
        border: `${pxToEm(1)} ${theme.color.neutral.light.swatch} solid`,

        fontSize: pxToEm(18),
        fontWeight: theme.typography.weight.medium,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'filter .15s ease-in 0s',
        '&:hover': {
            filter: 'brightness(83%)'
        },
        '&.selected-true':{
            color: theme.color.primary.medium.swatch,
            boxShadow: theme.boxShadow.inset,
            '&:hover': {
                filter: 'brightness(98%)'
            }
        },
        '&.selected-false':{
            color: theme.color.primary.dark.swatch
        }
    }
})